import { dashboardApi } from "@/api/dashboardApi";
import Breadcrumbs from "@/components/Breadcrumbs";
import Loading from "@/components/feedback/Loading";
import { Box, Container, Divider, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet, useSearchParams } from "react-router-dom";

const defaultFilter = {
    search: "",
    filter: {},
    sort: ["name", "-updated"],
    page: {
        number: 1,
        size: 15,
    },
};

function DashboardHubHeader() {
    return (
        <Box>
            <Typography variant="h1" fontSize={34} fontWeight="bold">
                DENT PSU
            </Typography>
            <Typography color="gray">SODD://Strategic Organization Development Dashboard</Typography>
        </Box>
    );
}

export default function DashboardHubLayout(props) {
    const [searchParams, setSearchParams] = useSearchParams();
    const [filter, setFilter] = useState(defaultFilter);
    const [refreshGetDashboards, getDashboards] = dashboardApi.endpoints.getAllDashboards.useLazyQuery();
    const dashboardsData = getDashboards.data?.data ?? [];
    const isLoading = getDashboards.isFetching;

    // console.log(searchParams);
    useEffect(() => {
        refreshGetDashboards(filter);
    }, []);

    return (
        <>
            <Container>
                <Breadcrumbs items={[{ label: "Dashboard Hub", to: "/dashboard-hub/search" }, { label: "Search" }]} />
            </Container>

            <Container>
                <DashboardHubHeader />
                <Divider sx={{ marginY: 1 }} />
            </Container>

            {/** content */}
            <Container sx={{ marginTop: 3 }}>
                {isLoading ? <Loading /> : <Outlet context={{ dashboards: dashboardsData }} />}
            </Container>
        </>
    );
}
